import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['notification']

  async copy(event) {
    event.preventDefault()

    const copyText = event.currentTarget.dataset.copyText
    if (!copyText) {
      console.error('No copy text found')
      return
    }

    const parentElement = event.currentTarget.closest('div')
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(copyText)
      } catch (err) {
        console.error('Failed to copy text: ', err)
        this.fallbackCopyText(copyText, parentElement)
      }
    } else {
      this.fallbackCopyText(copyText, parentElement)
    }

    // Show custom notification
    const notificationElement = this.notificationTarget
    if (notificationElement) {
      notificationElement.classList.add('show')
      setTimeout(() => {
        notificationElement.classList.remove('show')
      }, 2000) // Hide after 2 seconds
    }
  }

  fallbackCopyText(copyText, parentElement) {
    const tempInput = document.createElement('input')
    tempInput.value = copyText
    parentElement.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    parentElement.removeChild(tempInput)
    console.log('Text copied to clipboard (fallback)')
  }
}
